import { useCallback } from 'react'

import { useSetFocus } from '@please/lrud'
import { useLocation } from 'react-router-dom'

import { focusIds } from '@/constants/focus'
import { paths } from '@/constants/paths'
import useStore from '@/store/useStore'
import { sendPageViewEvent } from '@/utils/analyticsUtils'
import { sendPageImpressionToGTAG } from '@/utils/utils'

const useBackNavHistory = true

export const useOpenPrevPagePopup = () => {
  const setFocus = useSetFocus()
  const { pathname } = useLocation()

  return useCallback(() => {
    const state = useStore.getState()
    const { setListPopup } = state.common
    const { pagePopup, openPrevPage, closePagePopup } = state.popup
    const { divisionPopup, openPrevDivisionPopup, closeDivisionPopup } =
      state.soccerData
    pagePopup?.listOptions && setListPopup(pagePopup.listOptions)

    if (pagePopup?.prevPage && useBackNavHistory) {
      if (divisionPopup.pageId === pagePopup.id) {
        openPrevDivisionPopup()
      }
      return openPrevPage()
    }

    if (divisionPopup?.prevDivision?.division.length && useBackNavHistory) {
      return openPrevDivisionPopup()
    }

    closePagePopup()
    closeDivisionPopup()

    let path = pathname
    let focusId = `${focusIds.CONTENT}`

    if (pagePopup?.listOptions) {
      path = `${paths.LIST}/${pagePopup.listOptions.listContextId}/${pagePopup.listOptions.name}`
      focusId = `${focusIds.PAGE_POPUP}${focusIds.LIST}${focusIds.CONTAINER_MOD}`
    }

    sendPageViewEvent(path)
    sendPageImpressionToGTAG(path)

    setFocus(focusId)
  }, [setFocus, pathname])
}
